import { useQuery } from '@tanstack/react-query';

import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { notificationKeys } from './query-keys';

const POLL_INTERVAL_MS = 120_000;

export const useUnreadNotificationCount = (): {
    readonly isLoading: boolean;
    readonly unreadCount: number;
} => {
    const fetchers = useApplicationFetchers();
    const { data, isLoading } = useQuery({
        queryFn: async (): Promise<number> => {
            const result = await fetchers.getUnreadNotificationCount();

            if (result.isErr) {
                throw result.error;
            }

            return result.value.count;
        },
        queryKey: notificationKeys.unreadCount(),
        refetchInterval: POLL_INTERVAL_MS,
        staleTime: 30_000,
        throwOnError: false,
    });

    return { isLoading, unreadCount: data ?? 0 };
};
